import api from "./helper/client"
import { API_ROUTES } from "./helper/routes"

export const getApprovalEmployeesList = async (tenantId: number) => {
    const data = {
        tenant_id: tenantId
    }
    const response = await api.post(`${API_ROUTES.DOWNLINE}/list`, data);
    return response;
}

export const getTourPlansViaEmployee = async (tenantId: number, employeeId: number) => {
    const data = {
        tenant_id: tenantId,
        employee_id: employeeId
    }
    const response = await api.post(`${API_ROUTES.DOWNLINE}/tour-plans`, data)
    return response;
}

export const getLeavesViaEmployee = async (tenantId: number, employeeId: number) => {
    const data = {
        tenant_id: tenantId,
        employee_id: employeeId
    }
    const response = await api.post(`${API_ROUTES.DOWNLINE}/leaves`, data)
    return response;
}